// client/guest/components/DoneBlock.tsx
// client/guest/components/DoneBlock.tsx
import React from "react";

export default function DoneBlock() {
  return (
    <div className="grid gap-3 text-center">
      <div className="mx-auto w-12 h-12 rounded-2xl bg-emerald-600/20 grid place-items-center text-emerald-300 text-xl">
        ✓
      </div>
      <div className="text-[15px] font-semibold text-white">
        Вы уже прошли Face Control
      </div>
    </div>
  );
}